import { telemetryPath, telemetryReferrer } from "./telemetryPrivacy";
import { getConsent } from "./consentStore";
export interface FirstTouchAttribution {
    source: string;
    platform: string;
    landingPage: string;
    referrer?: string;
    utmMedium?: string;
    utmCampaign?: string;
    sessionId: string;
    capturedAt: string;
}

const STORAGE_KEY = "ch_first_touch_attribution";

const getPlatform = (): string => {
    const ua = navigator.userAgent.toLowerCase();
    const isNative = Boolean((window as any).flutter_inappwebview);

    if (isNative && /iphone|ipad|ipod/.test(ua)) return "iOS App";
    if (isNative && /android/.test(ua)) return "Android App";
    if (/iphone|ipad|ipod|android|mobile/.test(ua)) return "Mobile Web";
    return "Web";
};

const getSource = (params: URLSearchParams, referrer: string): string => {
    const utmSource = params.get("utm_source")?.trim();
    if (utmSource) return "campaign";
    if (params.has("gclid")) return "google_ads";
    if (params.has("fbclid")) return "meta_ads";
    if (!referrer) return "direct";

    try {
        const host = new URL(referrer).hostname.replace(/^www\./, "").toLowerCase();
        if (host.includes("google.")) return "google_organic";
        if (host.includes("bing.")) return "bing_organic";
        if (host.includes("instagram.")) return "instagram";
        if (host.includes("facebook.") || host === "fb.com") return "facebook";
        if (host.includes("tiktok.")) return "tiktok";
        if (host === "x.com" || host.includes("twitter.")) return "x";
        return `referral:${host}`.slice(0, 100);
    } catch {
        return "unknown_referral";
    }
};

export const captureFirstTouch = (): FirstTouchAttribution | null => {
    if (typeof window === "undefined") return null;
    if (!getConsent().analytics) { localStorage.removeItem(STORAGE_KEY); return null; }

    try {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) {
            const stored = JSON.parse(existing) as FirstTouchAttribution;
            const clean = { ...stored, landingPage: telemetryPath(stored.landingPage), referrer: telemetryReferrer(stored.referrer || ""), source: "returning", utmMedium: undefined, utmCampaign: undefined };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
            return clean;
        }

        const params = new URLSearchParams(window.location.search);
        const referrer = document.referrer || "";
        const attribution: FirstTouchAttribution = {
            source: getSource(params, referrer),
            platform: getPlatform(),
            landingPage: telemetryPath(window.location.pathname),
            referrer: telemetryReferrer(referrer) || undefined,
            utmMedium: undefined,
            utmCampaign: undefined,
            sessionId: crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
            capturedAt: new Date().toISOString()
        };

        localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
        return attribution;
    } catch {
        return null;
    }
};

export const getFirstTouch = (): FirstTouchAttribution | null => captureFirstTouch();
